import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {OverlayService} from '@aztrix/components/overlay';
import {CustomValidators} from '@aztrix/helpers';
import {FormControl} from '@ngneat/reactive-forms';
import {first, Observable} from 'rxjs';

@Component({
  selector: 'ax-retry-verification',
  templateUrl: './retry-verification.component.html',
  styleUrls: ['./retry-verification.component.scss'],
})
export class RetryVerificationComponent implements OnInit, OnDestroy {
  @Input() form = new FormControl('', [CustomValidators.validateLoginValue()]);
  @Input() startDate: number | undefined;
  @Input() canChangeValue: boolean;
  @Input() verificationType: 'EMAIL' | 'MOBILE';
  @Input() retryVerification: (verificationValue: string) => Observable<any>;

  @Output() verificationValueChanges = new EventEmitter<string>();

  private _interval: NodeJS.Timeout;
  private _mobileForm = new FormControl<string>();
  private _emailForm = new FormControl<string>();

  countDown = 0;

  constructor(
    private _overlay: OverlayService,
    private _changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.countDown = this.startDate ? this.startDate : 0;
    this._mobileForm.valueChanges.subscribe((value) => {
      this.form.setValue(value);
    });
    this._emailForm.valueChanges.subscribe((value) => {
      this.form.setValue(value);
    });

    this.startTimer();
  }

  ngOnDestroy(): void {
    clearInterval(this._interval);
  }

  startTimer() {
    this._interval = setInterval(() => {
      this._changeDetector.detectChanges();
    }, 1000);
  }

  resendVerification() {
    this.retryVerification(<string>this.form.value)
      .pipe(first())
      .subscribe({
        error: (error) => {
          if (error.error === 'AGREEMENT_ALREADY_VERIFIED') {
            this._overlay.closeModal();
          }
        },
        next: () => {
          this.verificationValueChanges.next(<string>this.form.value);
          this._overlay.closeModal();
        },
      });
  }
}
